import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	filterPlaceholder: {
		id: 'project-settings-apps-issue-type-page-product-features.common.sidebar.filter.filter-placeholder',
		defaultMessage: 'Type to search',
		description:
			'Placeholder for the search input, which can be used to search through fields list.',
	},
	filterLabel: {
		id: 'project-settings-apps-issue-type-page-product-features.common.sidebar.filter.filter-label',
		defaultMessage: 'Search fields in this project',
		description: 'Label for the search input, which can be used to search through fields list.',
	},
	matchingItemsCount: {
		id: 'project-settings-apps-issue-type-page-product-features.common.sidebar.filter.matching-items-count',
		defaultMessage: '{count, plural, one {# result matches} other {# results match}} your search',
		description: "Information about the total number of fields matching user's request",
	},
});
